import { render, staticRenderFns } from "./AddAsinInfo.vue?vue&type=template&id=d2be952a&"
import script from "./AddAsinInfo.vue?vue&type=script&lang=ts&"
export * from "./AddAsinInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AddAsinInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports